import { Address, beginCell, Cell } from 'ton-core';

export interface RoyaltyConfig {
    numerator: number;
    denominator: number;
    royaltyAddress: Address;
}

export const royaltyConfigToCell = (config: RoyaltyConfig) => {
    return beginCell()
        .storeUint(config.numerator, 16)
        .storeUint(config.denominator, 16)
        .storeAddress(config.royaltyAddress)
        .endCell();
};

export const royaltyCellToConfig = (data: Cell): RoyaltyConfig => {
    const slice = data.beginParse();
    const numerator = slice.loadUint(16);
    const denominator = slice.loadUint(16);
    const royaltyAddress = slice.loadAddress();
    return {
        numerator,
        denominator,
        royaltyAddress,
    };
};
